"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PosaRedeemActions_1 = __importDefault(require("../actions/PosaRedeemActions"));
const Url_1 = __importDefault(require("../constants/Url"));
const axios_1 = __importDefault(require("axios"));
const common_1 = require("@epic-core/common");
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * PosaRedeemSource
 */
const PosaRedeemSource = {
    getCmsContent: {
        remote(state) {
            const url = Url_1.default().POSA.GET_CMS_CONTENT(common_1.getLocale());
            return axios_1.default.get(url);
        },
        success: PosaRedeemActions_1.default.getCmsContentSuccess,
        error: PosaRedeemActions_1.default.getCmsContentFailure
    },
    validateCode: {
        remote(state, code) {
            const url = Url_1.default().POSA.GET_CARD_STATUS(common_1.getLocale());
            return axios_1.default.post(url, { code });
        },
        success: PosaRedeemActions_1.default.validateCodeSuccess,
        error: PosaRedeemActions_1.default.validateCodeFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    },
    redeemCode: {
        remote(state, code, payload) {
            const url = Url_1.default().POSA.REDEEM_CARD(common_1.getLocale());
            return axios_1.default.post(url, Object.assign({ code }, payload));
        },
        success: PosaRedeemActions_1.default.redeemCodeSuccess,
        error: PosaRedeemActions_1.default.redeemCodeFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    }
};
exports.default = PosaRedeemSource;
//# sourceMappingURL=PosaRedeemSource.js.map